export const getSelectedClinic = () => {
  try {
    return JSON.parse(localStorage.getItem("selectedClinic"));
  } catch {
    return null;
  }
};

export const setSelectedClinic = (clinic) => {
  localStorage.setItem(
    "selectedClinic",
    JSON.stringify(clinic)
  );
};

export const clearSelectedClinic = () => {
  localStorage.removeItem("selectedClinic");
};

export const getSelectedClinicId = () => {
  const clinic = getSelectedClinic();
  return clinic?.id || null;
};
